import { _ } from "libs";

import React from "react";
import { Ad } from "../../../types";

const AdItemMedium = ({ ad }: { ad: Ad }) => (
	<div className="item deal medium" offer-type={ad.offer_type}>
		{ad.featured === true ? <div className="badge featured">{_("deals.featured")}</div> : null}
		<div className="itemImage" style={{ backgroundImage: `url(${ad.picture})` }}>
			{ad.offer ? (
				<div className="offerValue">
					<div>{ad.offer}</div>
				</div>
			) : null}
		</div>
		<div className="itemBody">
			<div className="title">{ad.title}</div>
			{ad.content ? <p className="description">{ad.content}</p> : null}
		</div>
	</div>
);

export default AdItemMedium;
